import { useState } from 'react';
import {
  Button,
  Card,
  KeyValueList,
  Page,
  PageHeader,
  Typography,
  useToast,
} from '@platform/design-system';
import { ChangePasswordForm, ROLE_LABEL, TotpSettingsDialog, useSession } from '@platform/app-kit';

/** `/account` — the staff member's own account: change password, authenticator. */
export function AccountPage() {
  const { principal } = useSession();
  const toast = useToast();
  const [changing, setChanging] = useState(false);
  const [totpOpen, setTotpOpen] = useState(false);
  if (!principal) return null;
  return (
    <Page width="narrow">
      <PageHeader title="Account" meta={principal.email} />
      <Card title="Profile">
        <KeyValueList
          items={[
            { key: 'Name', value: principal.name },
            { key: 'Email', value: principal.email },
            {
              key: 'Role',
              value: principal.roles.map((r) => ROLE_LABEL[r]).join(', ') || 'No platform role',
            },
          ]}
        />
      </Card>
      <Card
        title="Password"
        action={
          changing ? undefined : (
            <Button size="small" onClick={() => setChanging(true)}>
              Change password
            </Button>
          )
        }
      >
        {changing ? (
          <ChangePasswordForm
            onDone={() => {
              setChanging(false);
              toast.success('Password changed');
            }}
            onCancel={() => setChanging(false)}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            Change it here at any time.
          </Typography>
        )}
      </Card>
      <Card
        title="Two-step verification"
        action={
          <Button size="small" onClick={() => setTotpOpen(true)}>
            Replace authenticator
          </Button>
        }
      >
        <Typography variant="body2" color="text.secondary">
          The console requires an authenticator app at every sign-in. Enrol a new one here if you
          change phones.
        </Typography>
      </Card>
      <TotpSettingsDialog open={totpOpen} onClose={() => setTotpOpen(false)} />
    </Page>
  );
}
